document.addEventListener("DOMContentLoaded", function() {
    new Swiper('.suot-product-slide__content.swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 6,
        loopFillGroupWithBlank: false,
        centeredSlides: true,
        grabCursor: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        speed: 3000,
        breakpoints: {
            750: {
                loopFillGroupWithBlank: true
            }
        }
    });
})